module.exports = __webpack_public_path__ + "img/fyt_p16.225cc7b7.png";